import axios from "axios";
import endpoints from "@/api/endpoints";

export class NewsletterService {
  static __instance = null;

  constructor() {
    if (NewsletterService.__instance) {
      return NewsletterService.__instance;
    }

    NewsletterService.__instance = this;
  }

  submit(data) {
    return axios.post(endpoints.newsletter, data).then(response => {
      if (response.data.success) {
        return response;
      } else throw new Error();
    });
  }
}

export const newsletterService = new NewsletterService();
